import React, { useEffect, useState } from 'react'
import { scaleLinear, scaleTime } from 'd3-scale'
import { line, curveBasis } from 'd3-shape'
import { dateformatX } from 'components/_utils'

import './styles.scss'
import useDimensions from './useDimensions'
const SCALEROUND = 100
export const Chart = ({
  countryData,
  country
}: {
  countryData: dataPoint[][]
  country: string
}) => {
  const [SVGEL, size, Node] = useDimensions()
  const plotArea = {
    left: 0,
    right: size.width - 20,
    top: 0,
    bottom: size.height - 50
  }

  const xAxisScale = React.useMemo(
    () =>
      scaleTime()
        .domain([0, 1])
        .range([0, 1]),
    [size.width, countryData]
  )
  const yAxisScale = React.useMemo(
    () =>
      scaleLinear()
        .domain([0, 1])
        .range([0, 1]),
    [size.height, countryData]
  )

  const xFunction = (d: dataPoint, i: number) => xAxisScale(new Date(d.d)) || 0
  const yFunction = (d: dataPoint, i: number) => yAxisScale(d.v) || 0

  // if (!countryData) return null

  let allvalues = (countryData || [])
    .map(m => m.map(d => d.v))
    .join(',')
    .split(',')
    .map(Number)

  let alldates = (countryData || [])
    .map(m => m.map(d => new Date(d.d).getTime()))
    .join(',')
    .split(',')
    .map(Number)

  let maxvalue = Math.round(Math.max(...allvalues) / SCALEROUND) * SCALEROUND

  let maxdate = Math.max(...alldates)

  yAxisScale.domain([0, maxvalue])
  yAxisScale.range([plotArea.bottom, plotArea.top])
  xAxisScale.domain([new Date('2020-01-01'), maxdate])
  xAxisScale.range([plotArea.left, plotArea.right])
  const lineFunction = React.useMemo(
    () =>
      line<dataPoint>()
        .x(xFunction)
        .y(yFunction)
        .curve(curveBasis),
    [size.width, size.height, countryData]
  )
  const yTicks = [0, maxvalue / 2, maxvalue]

  const xTicks = [
    '2020-01-01',
    '2020-04-01',
    '2020-07-01',
    '2020-10-01',
    '2021-01-01',

    '2021-04-01'
  ].map(m => new Date(m))

  return (
    <div className='Chart'>
      {countryData && (
        <>
          {' '}
          <div className='title'>Täglich bestätigte Fälle</div>
          <div className='sub'>
            Ø über 7 Tage der täglichen Fälle pro 100'000 Personen
          </div>
          <div className='key'>
            <div className='entry'>
              <div className='swatch a' />
              <div className='label'>{country}</div>
            </div>
            <div className='entry'>
              <div className='swatch b' />
              <div className='label'>Schweiz</div>
            </div>
          </div>
          <svg ref={SVGEL}>
            {xTicks.map((tick, i) => {
              return (
                <g
                  transform={`translate(${xAxisScale(tick)},${plotArea.bottom +
                    20})`}
                >
                  <line className='tick' y1={20} y2={-10} />

                  <text x={4} className='x'>{dateformatX(tick)}</text>
                  <text x={4} y={18} className='x'>
                    {tick.getFullYear()}
                  </text>
                </g>
              )
            })}

            {yTicks.map((tick, i) => {
              return (
                <g transform={`translate(0,${yAxisScale(tick)})`}>
                  <line
                    x1={plotArea.left}
                    x2={size.width}
                    className={'tick ' + (tick !== 0 ? '' : 'zero')}
                  />
                  {tick !== 0 && <text y={14}>{tick}</text>}
                </g>
              )
            })}

            <path
              d={lineFunction(countryData[0]) || ''}
              className={'country sel'}
              style={{
                stroke: '#9698A8',strokeWidth:"1.25px"
              }}
            />
            <path
              d={lineFunction(countryData[1]) || ''}
              className={'country sel'}
              style={{
                stroke: '#D3343F'
              }}
            />
          </svg>
        </>
      )}
    </div>
  )
}
